<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <v-card outlined>
      <v-card-title class="pb-0">
        <v-btn
          color="primary"
          small
          depressed
          :lang="$i18n.locale"
          @click="dialog = true"
        >
          <v-icon left> mdi-plus</v-icon>
          {{ $t('add') }}
        </v-btn>
      </v-card-title>

      <v-divider class="my-4"></v-divider>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="users"
          :loading="museumsLoader"
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="500">
      <form
        class="white d-flex flex-column pa-5"
        novalidate
        @submit.prevent="submit"
      >
        <div class="text-h6 text-center mb-5">{{ $t('newUser') }}</div>

        <v-text-field
          outlined
          label="Email"
          prepend-inner-icon="mdi-email"
          class="mb-1"
          type="email"
          v-model="email"
          :error-messages="emailErrors"
        ></v-text-field>

        <v-text-field
          outlined
          :label="$t('password')"
          prepend-inner-icon="mdi-lock"
          class="mb-1"
          type="password"
          v-model="password"
          :error-messages="passwordErrors"
        ></v-text-field>

        <v-text-field
          outlined
          :label="$t('confirmPassword')"
          prepend-inner-icon="mdi-lock"
          class="mb-1"
          type="password"
          v-model="confirmPassword"
          :error-messages="confirmPasswordErrors"
        ></v-text-field>

        <v-btn
          small
          color="primary"
          depressed
          class="align-self-center"
          type="submit"
          :loading="loader"
          :lang="$i18n.locale"
        >
          {{ $t('add') }}
        </v-btn>
      </form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import { required, email, sameAs } from "vuelidate/lib/validators";

const uniqueEmail = function () {
  return !this.emailExists;
};

export default {
  data() {
    return {
      headers: [
        {
          text: "Email",
          sortable: false,
          value: "email",
        },
        {
          text: this.$t('creationDate'),
          sortable: false,
          value: "createdAt",
        },
      ],
      dialog: false,
      email: "",
      password: "",
      confirmPassword: "",
      emailExists: false,
      loader: false,
    };
  },
  validations: {
    email: { required, email, uniqueEmail },
    password: { required },
    confirmPassword: { required, sameAsPassword: sameAs("password") },
  },
  computed: {
    ...mapState({
      activeMuseum: (state) => state.superuser.activeMuseum,
      museumsLoader: (state) => state.superuser.museumsLoader,
    }),
    users() {
      return this.activeMuseum.users.map((user) => {
        return {
          ...user,
          createdAt: moment(user.createdAt).format("DD/MM/YYYY"),
        };
      });
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required)
        errors.push(this.$t('fieldRequired'));
      if (!this.$v.email.email)
        errors.push(this.$t('invalidEmail'));
      if (!this.$v.email.uniqueEmail)
        errors.push(this.$t('emailExists'));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required)
        errors.push(this.$t('fieldRequired'));
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      if (!this.$v.confirmPassword.required)
        errors.push(this.$t('fieldRequired'));
      if (!this.$v.confirmPassword.sameAsPassword)
        errors.push(this.$t('passwordsDoNotMatch'));
      return errors;
    },
  },
  methods: {
    ...mapActions(["createUser", "getMuseums"]),
    ...mapMutations(["setActiveMuseum"]),
    async submit() {
      this.emailExists = false;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loader = true;

      try {
        await this.createUser({
          email: this.email,
          password: this.password,
          museumId: this.activeMuseum.id,
          roles: [
            "ROLE_ADMIN"
          ]
        });

        await this.getMuseums(true);

        this.setActiveMuseum(this.activeMuseum.id);

        this.dialog = false;

        this.email = "";
        this.password = "";
        this.confirmPassword = "";
        this.$v.$reset();
      } catch (e) {
        console.log(e);

        if (e?.response?.status == 400 && e?.response?.data?.data?.email) {
          this.emailExists = true;
        }
      }

      this.loader = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>